import React from 'react';
import { format } from 'date-fns';
import { prefixClass } from 'lib/utils';
import { KSButton } from 'presentation/components/KSQ2/Common';
import { IconCancel, IconValidateNew } from 'components/Icons';
import './SimpleDatePicker.scss';

export interface SimpleDatePickerProps {
  /** Currently selected date */
  selectedDate?: Date | null;
  /** Callback when date changes */
  onDateChange: (date: Date | null) => void;
  /** Callback when confirmed */
  onConfirm: () => void;
  /** Callback when cleared */
  onClear?: () => void;
}

/**
 * Simple date picker using native HTML input
 * Temporary solution until the full DueDatePicker is connected
 */
export const SimpleDatePicker: React.FC<SimpleDatePickerProps> = ({
  selectedDate,
  onDateChange,
  onConfirm,
  onClear,
}) => {
  const prefix = prefixClass('simple-date-picker');

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value) {
      // Parse YYYY-MM-DD format from input
      const [year, month, day] = value.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      onDateChange(date);
    } else {
      onDateChange(null);
    }
  };

  // Format date for input value (YYYY-MM-DD)
  const inputValue = selectedDate ? format(selectedDate, 'yyyy-MM-dd') : '';

  // Get today's date for min attribute
  const today = format(new Date(), 'yyyy-MM-dd');

  return (
    <div className={prefix()}>
      <div className={prefix('__input-wrapper')}>
        <input type="date" className={prefix('__input')} value={inputValue} onChange={handleDateChange} min={today} />
      </div>
      <div className={prefix('__actions')}>
        {onClear && <KSButton variant="secondary" icon={<IconCancel />} label="Clear" onClick={onClear} />}
        <KSButton
          variant="primary"
          icon={<IconValidateNew />}
          label="Set Due Date"
          onClick={onConfirm}
          disabled={!selectedDate}
        />
      </div>
    </div>
  );
};

export default SimpleDatePicker;
